module.exports = __webpack_public_path__ + "static/media/listLegs.22119ccc.png";